import { render, staticRenderFns } from "./FileField.vue?vue&type=template&id=2b2e5f52&scoped=true&"
import script from "./FileField.vue?vue&type=script&lang=ts&"
export * from "./FileField.vue?vue&type=script&lang=ts&"
import style0 from "./FileField.vue?vue&type=style&index=0&id=2b2e5f52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2e5f52",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
installComponents(component, {VCard,VFileInput})
